module.exports = __webpack_public_path__ + "odinstatic/media/create_demand.c37dc608.svg";